import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 lg:py-32 bg-[var(--ivory-2)]" data-testid="about-section">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <span className="overline" data-testid="about-overline">{t.about.overline}</span>
          <h2 className="font-serif text-[34px] sm:text-[42px] lg:text-[52px] leading-[1.08] tracking-tight text-[var(--navy)] mt-6" data-testid="about-title">
            {t.about.title}
          </h2>
          <div className="mt-8 w-14 h-px bg-[var(--champagne)]" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-7 lg:pt-14"
        >
          <p className="text-[17px] lg:text-[18px] leading-[1.8] text-[var(--charcoal)]" data-testid="about-p1">
            {t.about.p1}
          </p>
          <p className="text-[17px] lg:text-[18px] leading-[1.8] text-[var(--charcoal)] mt-6" data-testid="about-p2">
            {t.about.p2}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
